<div class="measurement-filter">
  <wlm-configurable-form
    [initialModel]="initialModel"
    [fieldConfig]="fieldConfig"
    [formOptions]="formOptions"
    [formDisabled]="isDisabled$ | async"
    (modelChange)="onModelChange($event)"
    (isValid)="onIsValid($event)"
    (hasChanges)="onHasChanges($event)"
  ></wlm-configurable-form>
  <button mat-raised-button class="filter-button" onclick="this.blur()" (click)="onClickApply()">
    {{ 'common.filter' | translate }}
  </button>
</div>
